import { render, staticRenderFns } from "./bill-items.vue?vue&type=template&id=17440d05&"
import script from "./bill-items.vue?vue&type=script&lang=ts&"
export * from "./bill-items.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports